import {getPaginated, RequestFilter, RequestOrder} from "../common/methods/ApiService";
import {API_URL} from "../common/struct/urlManager";
import {TWalletTransaction} from "../interfaces/wallet";

export async function getOperationRewards(operationId: string, page: number, itemsPerPage: number, search: string|null, order: RequestOrder|null, filters: RequestFilter[]|null): Promise<{totalItems: number, items: TWalletTransaction[]}> {
  return getPaginated(`${API_URL.OPERATION}/${operationId}/rewards`, page, itemsPerPage, search, order, filters);
}
